module.exports = {
  "id": "box",
  "title": "box",
  "image": "provision/parts/box/box.png",
  "info": [
    {
      "text": "Add a box to your project",
      "image": "provision/parts/box/box.png"
    }
  ],
  "exposedVariables": [],
  "codeImage": "provision/parts/box/box.png"
} ;